import { loaderStart, loaderStop, getOrdersSuccess } from './slices'
import { getStepsProviderError } from './../../components/Steps/slices'
import Api from 'utils/api'
import { showPopup } from '../../components/Modal/slices'

export const getOrders = (orderId = '') => async (dispatch) => {
	try {
		dispatch(loaderStart())
		Api.get('/orders')
			.then((data) => {
				dispatch(
					getOrdersSuccess({
						data,
						orderId,
					})
				)
				dispatch(getStepsProviderError())
			})
			.catch((error) => {
				dispatch(loaderStop())
				dispatch(showPopup(error))
			})
	} catch (error) {
		dispatch(loaderStop())
	}
}
